import { Injectable } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { CfgService } from '../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class FeaturePermissionsCfg {
  public professionalsResourceId: number;
}

@Injectable({
  providedIn: 'root'
})
export class FeaturePermissionsCfgService extends CfgService<FeaturePermissionsCfg> {
  json: any = {
    professionalsResourceId: 1694
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/featurePermissions.cfg.json`;
  }

  /**
   * Carga las url en el json
   */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
